import { useMemo } from 'react';
import { selectors as authSelectors } from 'state/auth';
import { useSelector } from 'react-redux';

const useShowNewSoForm = () => {
  const permissions = useSelector(authSelectors.getUserPermissions) || [];
  const forceClassicForm = permissions.includes('core.force_classic_form');
  const showNewForm = !forceClassicForm;

  return useMemo(() => showNewForm, [showNewForm]);
};

export default useShowNewSoForm;
